import React, { useCallback } from 'react';
import { useField } from 'formik';
interface RoomFiltersProps {
  name: string;
  options: { label: string; value: string }[];
  role: 'checkbox' | 'radio';
  onValueChange?: (value: string | string[]) => void;
  isMulti?: boolean;
}

const RoomFilters: React.FC<RoomFiltersProps> = ({ name, options, role, onValueChange, isMulti }) => {
  const [field, , helpers] = useField<string | string[]>(name);

  const handleClick = useCallback((value: string) => {
    if (role === 'checkbox' && isMulti) {
      // Handle multi-checkbox: toggle values in array
      const currentValue = Array.isArray(field.value) ? field.value : [];
      const newValue = currentValue.includes(value)
        ? currentValue.filter(val => val !== value)
        : [...currentValue, value];
      helpers.setValue(newValue);
      onValueChange && onValueChange(newValue);
    } else if (role === 'checkbox' && !isMulti) {
      // Handle single checkbox: toggle between 'yes' and 'no'
      const newValue = field.value === 'yes' ? 'no' : 'yes';
      helpers.setValue(newValue);
      onValueChange && onValueChange(newValue);
    } else {
      // Handle radio: select single value
      helpers.setValue(value);
      onValueChange && onValueChange(value);
    }
  }, [field.value, helpers, isMulti, onValueChange, role]);

  return (
    <>
      {options?.map((option, index) => {
        // Determine if this option is selected
        const isSelected = role === 'checkbox' && isMulti
          ? Array.isArray(field.value) && field.value.includes(option.value)
          : role === 'checkbox'
          ? field.value === 'yes'
          : field.value === option.value;

        return (
          <button
            name={`${name}_${index}`}
            key={option.value}
            type="button"
            className={`btn d-flex align-items-center rounded-pill px-3 py-1 text-12 ${
              isSelected ? '-dark-1 bg-blue-1 text-white' : 'room-btn'
            }`}
            onClick={() => handleClick(option.value)}
            aria-checked={isSelected}
            role={role}
          >
            {/* <CalendarCheckIcon isSelected={isSelected} /> */}
            <span>{option.label}</span>
          </button>
        );
      })}
    </>
  );
};

export default RoomFilters;